import {action, observable} from 'mobx';
import { getGroupAppInstallUninstallList, getGroupAppList, getGroupAppRunStopList, appRun, appStop, appInstallUninstall } from '@/services/Home';
import UserStore from '@/stores/user';
import * as R from 'ramda';
import DeviceStore from '@/stores/device';
import {message} from 'antd';
import log from '@/utils/log';

export interface groupAppType {
    id: number;
    innerLink: string;
    bundleId: number;
    appName: number;
}

class AppManagementStore {
  
  /* 选中的应用id */
  @observable activeAppId: string | number;
  
  @observable.ref groupAppList: groupAppType [] = []
  
  /* 安装列表 */
  @observable.ref groupAppInstallList: any [] = []
  
  /* 未安装列表 */
  @observable.ref groupAppUninstall: any [] = []
  
  /* 备份数据 */
  
  @observable.ref appList : any [] = []
  
  /* 运行停止游戏列表 */
  @observable.ref groupAppRunStopList: any [] = []
  
  /* 获取安装和未安装的 */
  @action.bound async getInstallUninstallList () {
    const [error, result] = await getGroupAppInstallUninstallList({
      groupId: UserStore.GroupStore.activeGroupId
    });
    if (error) {
      log({ pageId: 'P10', eventId: 'E1001',  ext: ''})
      return ;
    }
    log({ pageId: 'P10', eventId: 'E1000',  ext: ''})
    const groupAppInstallList = result.installList.map((r: any) => ({name: r.gameName, id: r.gameId}));
    const groupAppUninstall = result.notInstallList.map((r: any) => ({name: r.gameName, id: r.gameId}));
    this.appList = [groupAppInstallList, groupAppUninstall]
    this.groupAppInstallList = groupAppInstallList
    this.groupAppUninstall = groupAppUninstall
    
  }
  
  @action.bound async getGroupAppList () {
    
    const [error, result] = await getGroupAppList({
      groupId: UserStore.GroupStore.activeGroupId
    });
    
    if (error) return ;
    
    this.groupAppList = result.gameList
    
  }
  
  @action.bound async getGroupAppRunStopList () {
    
    const [error, result] = await getGroupAppRunStopList({
      groupId: UserStore.GroupStore.activeGroupId
    });
  
    if (error && !result.myGameList) return ;
    
    this.groupAppRunStopList = result.myGameList
    
  }
  
  @action.bound setActiveAppId (activeAppId: string | number) {
    
    this.activeAppId = activeAppId;
    
  }
  
  @action.bound async appRun () {
  
    const ids =  DeviceStore.DeviceOperation.RebootStore.selectedIds
    
    const [error] = await appRun({
      ids: R.join(',',ids),
      groupId: UserStore.GroupStore.activeGroupId,
      gameId: this.activeAppId
    });
    
    if (error) {
      log({ pageId: 'P11', eventId: 'E1105',  ext: ids.toString()})
      return false;
    }
  
    log({ pageId: 'P11', eventId: 'E1104',  ext: ids.toString()})
  
  
    message.success('操作成功');
  
    await  DeviceStore.DeviceBaseStore.getDeviceList({groupId: UserStore.GroupStore.activeGroupId});
  
    return true
    
  }
  
  @action.bound async appStop (cid? : string) {
  
    const ids = cid ? DeviceStore.DeviceOperation.RebootStore.selectedId(cid) :
      DeviceStore.DeviceOperation.RebootStore.selectedIds
  
    const [error] = await appStop({
      ids: R.join(',',ids),
      groupId: UserStore.GroupStore.activeGroupId,
      gameId: this.activeAppId
    });
    
    if (error) {
      log({ pageId: 'P31', eventId: 'E3105',  ext: ids.toString()})
      return false;
    }
    log({ pageId: 'P31', eventId: 'E3104',  ext: ids.toString()})
  
    message.success('操作成功');
    return true
    
  }
  
  
  @action.bound setInUnList (data: {id: number, name: string, type: string}) {
  
    console.log(data);
  
    const isEven = (n: {id: number}) => n.id !== data.id;
    
    if (data.type === 'delete') {
      this.groupAppInstallList = R.filter(isEven, this.groupAppInstallList);
      this.groupAppUninstall = this.groupAppUninstall.concat([{id: data.id,name: data.name}])
    }
    
    if (data.type === 'add') {
      this.groupAppUninstall = R.filter(isEven, this.groupAppUninstall);
      this.groupAppInstallList = this.groupAppInstallList.concat([{id: data.id,name: data.name}])
  
    }
    console.log(this.groupAppUninstall, this.groupAppInstallList);
  }
  
  @action.bound async appInstallUninstall () {
    console.log(this.appList);
    const installGameIds = this.groupAppInstallList.length === 0 ? 0 :
      R.join(',',this.groupAppInstallList.map((r:any) => r.id))
    const unInstallGameIds = this.groupAppUninstall.length === 0 ?  0 :
      R.join(',',this.groupAppUninstall.map((r: any) => r.id))
    console.log(installGameIds, unInstallGameIds)
    const [error] = await appInstallUninstall({
      installGameIds: installGameIds ,
      unInstallGameIds: unInstallGameIds,
      groupId: UserStore.GroupStore.activeGroupId
    })
    
    if (error) {
      log({ pageId: 'P10', eventId: 'E1005',  ext: installGameIds + '|' + unInstallGameIds})
      return
    }
    log({ pageId: 'P10', eventId: 'E1004',  ext: installGameIds + '|' + unInstallGameIds})
  
    message.success('操作成功！')
    
  }
  
  
}

export default AppManagementStore;
